export default __webpack_public_path__ + "static/media/longarrow.6427b658.svg";